import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareBoardsCustomFiltersRoute: InvariantJiraRoute = {
	name: 'project-settings-software-boards-custom-filters',
	path: '/jira/software/projects/:projectKey/settings/boards/:boardId/custom-filters',
	exact: true,
};
